var CompanySearchMixins = {

    methods: {
        getCountryLabel(countryCode) {
            
            switch (countryCode) {
                case 'FR':
                    return window.i18n.__('France');

                case 'GB':
                    return window.i18n.__('Royaume-Uni');

                case 'BE':
                    return window.i18n.__('Belgique');

                default:
                    throw new Error('countryCode in CompanySearchMixins is not valid')
            }
        },
        districtValidator(rule, value, callback) {
            if(value !== "" && !value.match(/^[0-9]{2}|2[AB]|97[0-9]$/g)) {
                callback(new Error(window.i18n.__('Département non valide')));
            } else {
                callback();
            }
        }
    }
}

export default CompanySearchMixins;
